import { ERRORS } from '../constants';

export const DEFAULT_QUOTE_HELP_COPY = 'Unfortunately we are unable to complete your application at this time.';
export const INVALID_AGENCY_GUID_COPY =
  'An insurance agent is required to continue, but this quote isn’t currently associated with one. Please reach out to your insurance agent for an updated quote link.';

export const MDA_AGENT_LOOKUP_FAILURE_COPY =
  'There was an issue identifying the agent required to generate this quote. Please reach out to your insurance agent for an updated quote link.';

export const quoteHelpCopy = (error) => {
  switch (error) {
    case ERRORS.CAT_1.NUMBER_OF_EMPLOYEES_OUTSIDE_BOUNDS:
    case ERRORS.CAT_1.PREVIOUS_LOSSES_OUTSIDE_BOUNDS:
    case ERRORS.CAT_1.REVENUE_OUTSIDE_BOUNDS:
      return 'Based on the specialized nature and/or size of your business operations one of our agents will need to assist with their policy quote.';
    case ERRORS.CAT_1.ZIP_CODE_OUTSIDE_BOUNDS:
      return "We're sorry, It looks like we are not currently offering insurance in your area. If you have any questions please call the number below.";
    case ERRORS.CAT_1.INVALID_INDUSTRY_ID:
      return "It looks like we don't currently support your industry.";
    case ERRORS.CAT_1.DECLINATION_ERROR:
      return 'Based on information you provided, as well as publicly available information, we determined this business does not meet our underwriting guidelines \n for the following reasons:';
    default:
      return DEFAULT_QUOTE_HELP_COPY;
  }
};
